module.exports = __webpack_public_path__ + "img/av259.f8475741.png";